import { AbstractControl, ValidatorFn } from '@angular/forms';

export function PasswordStrengthValidator(minLength: number = 12): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value || '';
    if (!value) {
        return null;
    }

    const hasUpperCase = /[A-Z]+/.test(value);
    const hasLowerCase = /[a-z]+/.test(value);
    const hasNumeric = /[0-9]+/.test(value);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]+/.test(value);
    const hasMinLength = value.length >= minLength;

    const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecial && hasMinLength;

    return !passwordValid ? { password_strength: { hasUpperCase, hasLowerCase, hasNumeric, hasSpecial,hasMinLength } } : null;
};
}
